<template lang="pug">
  .env-marker(v-if="env") {{ env }}
</template>

<script>
import Security from '@/service/apis/Security'

export default {
  data: () => ({
    env: null
  }),
  created() {
    Security.userInfo()
      .then((r) => {
        const env = r.data.title.toLowerCase()
        if (env && (env === 'dev' || env === 'demo' || env === 'qa')) {
          this.env = env.toUpperCase()
        }
      })
  }
}
</script>

<style <style lang="scss">
.env-marker {
  position: absolute;
  top: 0;
  left: 0;
  font-size: 14px;
  font-weight: 400;
  background: #000;
  color: #1affd5;
  padding: 6px 18px;
  text-transform: uppercase;
  letter-spacing: 1px;
}
</style>



// WEBPACK FOOTER //
// src/components/ssp/EnvMarker.vue